import { getProps } from 'utils/global-utils';
import fetchApi from 'utils/api-utils';

type GetServiceStatusParams = {
  caseId?: string;
  moveVersion: string;
  partner?: string;
  tenantId: string;
  token: string;
};

const SYNERGY_BASEURL_AZURE_FUNCTIONS =
  process.env.REACT_APP_SYNERGY_BASEURL_AZURE_FUNCTIONS;
const GET_SERVICE_STATUS_URL = `${SYNERGY_BASEURL_AZURE_FUNCTIONS}/api/servicesStatus`;

export const getServiceStatus = async ({
  caseId,
  moveVersion,
  partner,
  tenantId,
  token,
}: GetServiceStatusParams) =>
  fetchApi(GET_SERVICE_STATUS_URL, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'x-env': process.env.REACT_APP_ABODE_ENV,
      'x-partner': partner,
      'x-provider': moveVersion,
      'x-requested-by': 'synergy',
      'x-tenant-id': tenantId,
      'x-token': token,
    },
    params: {
      case_id: caseId,
    },
  }).then(async rs => {
    const data = getProps(rs, 'json') && (await rs.json());
    return { status: rs.status, ok: rs.ok, result: data };
  });

export default getServiceStatus;
